import React__default from 'react';
import { P as Popover } from './Popover-7e83b807.js';

var styles = {"content":"Tooltip_content_0ab83303","title":"Tooltip_title_0ab83303","body":"Tooltip_body_0ab83303"};

var TooltipContent = function (_a) {
    var children = _a.children, title = _a.title;
    return (React__default.createElement("div", { className: styles.content },
        title && React__default.createElement("div", { className: styles.title }, title),
        children && React__default.createElement("div", { className: styles.body }, children)));
};
var Tooltip = function (props) {
    var _a = React__default.useState(false), isHover = _a[0], setHover = _a[1];
    var isOpen = props.isOpen, children = props.children, _b = props.placement, placement = _b === void 0 ? "right" : _b, className = props.className, dataTestId = props["data-testid"], content = props.content, _c = props.variant, variant = _c === void 0 ? "default" : _c;
    var handleMouseEnter = function () {
        setHover(true);
    };
    var handleMouseLeave = function () {
        setHover(false);
    };
    return (React__default.createElement(Popover, { isOpen: isOpen || isHover, onClose: function () { return undefined; }, placement: placement, showArrow: true, disableOverlay: true, disableScale: true, variant: variant, removePadding: true, content: React__default.createElement("div", { "data-testid": dataTestId, className: className, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave }, content) }, children));
};

export { Tooltip as T, TooltipContent as a };
